import { UtilityText } from '@policygenius/mortar';
import React from 'react';

import { CLICKED_LINK_EVENT } from 'analytics/constants';
import { frontendAnalyticsTrack } from 'analytics/utils';

import { ANALYTICS_SOURCE } from './constants';
import classes from './footer.module.scss';

const Footer = () => {
  const onClick = ({ text, href }: { text: string; href: string }) => {
    frontendAnalyticsTrack(CLICKED_LINK_EVENT, {
      href,
      source: ANALYTICS_SOURCE,
      text,
    });
  };

  return (
    <footer className={classes.footer}>
      <ul className={classes.links}>
        <li>
          <UtilityText
            className={classes.link}
            as="a"
            size="xsmall"
            color="secondary"
            onClick={() =>
              onClick({
                text: 'Privacy',
                href: '/about/privacy',
              })
            }
            href={'/about/privacy'}
          >
            Privacy
          </UtilityText>
        </li>
        <li>
          <UtilityText
            className={classes.link}
            as="a"
            size="xsmall"
            color="secondary"
            onClick={() =>
              onClick({
                text: 'Terms of Services',
                href: '/about/terms',
              })
            }
            href={'/about/terms'}
          >
            Terms of Services
          </UtilityText>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
